import { Item } from 'typings'
import {
  GIFT_APPLICATION,
  RegularBenefitVariant,
  RegularGift,
} from '../../../../../../../typings'

export const EMPTY_GIFT: RegularGift = {
  type: RegularBenefitVariant.Gift,
  items: [] as Item[],
  application: GIFT_APPLICATION.PER_CART,
  maxQuantity: 1,
}
